import { useEffect, useState } from "react";
import { JobPartCategory } from "../../models/Job";
import classNames from "../../utils/classNames";
import openInNewTab from "../../utils/openInNewTab";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import ContactFromId from "../contacts/ContactFromId";


interface JobPartProps {
  partCategory: JobPartCategory;
  markAsRemoved: (partData: JobPartCategory['partData']) => void;
  setDamaged: (partData: JobPartCategory['partData']) => void;
  setDamagedOpen: (open: boolean) => void;
  handlePrint: (partData: JobPartCategory['partData']) => void;
}

export default function JobPart({ partCategory, markAsRemoved, setDamaged, setDamagedOpen, handlePrint }: JobPartProps) {

  const [notes, setNotes] = useState(partCategory.partData?.internalNotes);

  return (
    <div key={partCategory.id} className="p-4 rounded-md bg-white space-y-4">
      <div className="flex gap-x-2 items-center">
        <p className="text-lg font-semibold">{partCategory.partData?.title} - <span className="text-base font-medium">{partCategory.partData?.tagNumber}</span></p>

        {partCategory.partData?.removedOn && (
          <p className="font-semibold text-green-600">REMOVED</p>
        )}
        {partCategory.partData?.isDamaged && (
          <p className="font-semibold text-red-600">DAMAGED</p>
        )}
      </div>

      <div className="flex flex-col md:flex-row gap-x-4 gap-y-2">

        {!partCategory.partData?.isDamaged && (
          <>
            <ButtonInput
              label={"Mark Removed"}
              isSubmit={false}
              onClick={() => markAsRemoved(partCategory.partData!)}
              classes={classNames(partCategory.partData?.removedOn ? "" : "!bg-green-600 hover:!bg-green-700", "!py-1 !px-1")}
              disabled={partCategory.partData?.removedOn !== null}
            />
            <ButtonInput
              label={"Mark Damaged"}
              isSubmit={false}
              onClick={() => { setDamaged(partCategory.partData); setDamagedOpen(true); }}
              classes={"!py-1 !px-1 !bg-red-600 hover:!bg-red-700"}
            />
          </>
        )}

        <ButtonInput
          label={"View Stock"}
          isSubmit={false}
          onClick={() => openInNewTab(`/stock/${partCategory.partData?.id}`)}
          classes={"!py-1 !px-1 "}
        />

        <ButtonInput
          label={"Print Label"}
          isSubmit={false}
          onClick={() => handlePrint(partCategory.partData!)}
          classes={"!py-1 !px-1 "}
        />
      </div>

      {notes && notes.length > 0 &&
        <div>
          <h1>Internal Part Notes:</h1>
          <ul className="text-sm list-disc">
            {notes.map((note) => (
              <li className="ml-5">{note.message} - <ContactFromId contactId={note.createdBy} /></li>
            ))}
          </ul>
        </div>
      }
    </div>
  )
}